var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"map fill-height",style:(_vm.mapSize),attrs:{"id":"map"}}),_c('marker-on-map'),_c('popup-on-map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }